module.exports = __webpack_public_path__ + "media/organizations/Siemens-376063fa.webp";